export default __webpack_public_path__ + "static/media/timeline-empty.b2180cfa.jpg";